import React, { Component } from "react";
import { connect } from "react-redux";
import { SaveUserStateToServerHelper } from "../Helper";
import GeneralInstruction from "./GeneralInstruction";
import PracticeInstruction from "./PracticeInstruction";

export class Instruction extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  render() {
    let Instruction = null;

    if (
      (["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name) &&
        !this.props.is_practice_done) ||
      (["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name) &&
        !this.props.is_practice_done)
    ) {
      Instruction = <PracticeInstruction />;
    } else {
      Instruction = <GeneralInstruction />;
    }

    return <>{Instruction}</>;
  }
}

const mapStateToProps = (state) => ({
  ...state,
  exam_name: state.assessment.exams[state.assessment.exam_index].name,
  is_practice_done:
    state.assessment.exams[state.assessment.exam_index].is_practice_done,
});

export default connect(mapStateToProps)(Instruction);
